import { post, get } from "../../../../services/request";

// Get Capacity Input Data
export const getCapacityInputData = (filterModel = {}) => {
  const params = {};
  if (filterModel?.ProviderIds) params.ProviderIds = filterModel.ProviderIds;
  if (filterModel?.ProviderTypeIds) params.ProviderTypeIds = filterModel.ProviderTypeIds;
  if (filterModel?.LocationIds) params.LocationIds = filterModel.LocationIds;
  return get("RadCapacity/GetAllRadCapacityInput", params);
};

// Get Default RAD Capacity
export const getDefaultRadCapacity = () => {
  return get("DefaultRadCapacity/GetDefaultRadCapacity");
};

// Update RAD Capacity Input
export const updateRadCapacityInput = (updateData) => {
  return post("DefaultRadCapacity/SaveDefaultRadCapacity", updateData);
};

// Bulk Update RAD Capacity Input
export const bulkUpdateRadCapacityInput = (bulkData) => {
  return post("RadCapacity/BulkRadCapacityUpdate", bulkData);
};

// Rad Capacity IP Upload
export const radCapacityIpUpload = (formData) => {
  return post("RadCapacity/RadCapacityIpUpload", formData);
};
